import * as svg from "../../../assets/paper-plane-outline-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PaperPlaneOutlineIcon = iconBuilder(svg, "PaperPlaneOutlineIcon", "0 0 21 21");
